import { API_CONFIG, ADMIN_ENDPOINTS } from '@/project/configs/api.js';

export default {
  url(payload) {
    const { includeInactive = true } = payload || {};
    const params = new URLSearchParams();
    params.append('group', 'ultraxeno');
    if (includeInactive) params.append('includeInactive', 'true');
    params.append('limit', 2000);

    return `${API_CONFIG.baseURL}${ADMIN_ENDPOINTS.ADMIN_CATEGORIES}?${params.toString()}`;
  },

  parse(raw = {}, payload = {}) {
    if (!raw.success && raw.statusCode !== 200) {
      return {
        statusCode: raw?.statusCode || 500,
        message: raw?.message || 'Failed to fetch categories',
        data: null,
      };
    }

    let data = raw.data || [];
    const total = raw.total || data.length;

    if (payload?.search) {
      const searchLower = payload.search.toString().toLowerCase();
      data = data.filter(el => 
        (el.name && el.name.toLowerCase().includes(searchLower)) || 
        (el.id && el.id.toLowerCase().includes(searchLower))
      );
    }

    // === Tri dynamique selon payload.sortKey et sortOrder ===
    let finalData = data
    const { sortKey, sortOrder } = payload || {}
    if (sortKey) {
      const order = sortOrder === 'desc' ? -1 : 1
      finalData = [...finalData].sort((a, b) => {
        const valA = a?.[sortKey]
        const valB = b?.[sortKey]
        if (typeof valA === 'string' && typeof valB === 'string') return valA.localeCompare(valB) * order
        if (typeof valA === 'number' && typeof valB === 'number') return (valA - valB) * order
        return 0
      })
    }

    // === Pagination locale ===
    const { page = 0, limit = 100 } = payload || {}
    const paginated = finalData.slice(page * limit, (page + 1) * limit)

    return {
      statusCode: 200,
      message: 'Ok',
      data: {
        total: total,
        result: paginated,
        page: payload?.page || 0,
        limit: payload?.limit || 100,
      },
    };
  },
};
